import axios from "axios";
import * as d3 from "d3";
import d3_timeseries from "../../library/d3_timeseries";

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.post(url, filterParam).then(res => {
        let data = res.data;

        data.forEach(function (d) {
            d.date = new Date(d.date)
        })

        d3.select(divId).select("svg").remove();
        var timechart = d3_timeseries()
            .addSerie(data.slice(0, chart.vizSpecific1), {x: 'date', y: 'actual_data'}, {
                interpolate: 'linear',
                color: "#a6cee3",
                label: "value"
            })
            .addSerie(data.slice(58),
                {x: 'date', y: 'forecast_data', ci_up: 'high_95', ci_down: 'low_95'},
                {interpolate: 'monotone', dashed: true, color: "#a6cee3", label: "prediction"}
            )
            .width(800)

        timechart(divId)
    });
}
